import { MessageTime } from "./style";

export default function MessageDate(props) {
  const date = new Date(props.date)
  // const offset = new Date().toString().match(/([-\+][0-9]+)\s/)[1]
  const offset = 3.5*60*60*1000
  const localDate = date.getTime() + offset
  return (
    <MessageTime className={props.className}>
      {new Intl.DateTimeFormat('fa-IR', {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
      }).format(new Date(localDate))}
    </MessageTime>
  );
}
